<div class="feature-container">
  <div *ngIf="NewFeatures != null && NewFeatures.length > 0" class="feature-section">
    <div class="feature-page__header d-flex justify-content-between align-items-center">
      <div>
        <h1>Feature</h1>
        <p class="subtitle">Stay updated with the latest features, updates, and announcements for the Milestone Project.
        </p>
      </div>
      <div class="counter ml-auto text-right">Showing {{NewFeatures?.length || 0}} releases</div>
    </div>

    <div class="feature-grid">
      <div class="feature-card" *ngFor="let feature of NewFeatures" (click)="openFeature(feature)">
        <div class="feature-card__header">
          <h3 class="card-title">{{ feature?.Title }}</h3>
        </div>

        <div class="feature-card__body">
          <div class="summary" [innerHTML]="contentWithoutImages(feature.Content)"></div>
        </div>

        <div class="feature-card__footer">
          <div class="footer-content">
            <span class="release-date">{{feature.UpdatedOn | date:'MMMM dd, yyyy'}}</span>
            <button class="btn-read-more" (click)="openFeature(feature)">Read More</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="featureReleases != null && featureReleases.length > 0" class="feature-section mt-4">
    <div class="feature-page__header d-flex justify-content-between align-items-center">
      <div>
        <h1>Feature Releases</h1>
        <p class="subtitle">Recent and upcoming releases for product teams.</p>
      </div>
      <div class="counter ml-auto text-right">Showing {{featureReleases?.length || 0}} releases</div>
    </div>

    <div class="feature-grid">
      <div class="feature-card" *ngFor="let feature of featureReleases" (click)="openFeature(feature)">
        <div class="feature-card__header">
          <h3 class="card-title">{{ feature?.Title }}</h3>
        </div>

        <div class="feature-card__body">
          <div class="summary" [innerHTML]="contentWithoutImages(feature.Content)"></div>
        </div>

        <div class="feature-card__footer">
          <div class="footer-content">
            <span class="release-date">{{feature.UpdatedOn | date:'MMMM dd, yyyy'}}</span>
            <button class="btn-read-more" (click)="openFeature(feature)">Read More</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>